const bannerArticles = [
    {
        name: "Audi hybrid jacket, women, orange",
        id: "15fc",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3132401601_1_audi_sport_hybridjacket_women_orange.jpg"
    },
    {
        name: "Audi sweatshirt, women, creme",
        id: "1601",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3132401701_1_audi_sport_sweatshirt_woman_creme.jpg"
    },
    {
        name: "Audi softshell hoodie, unisex, light grey",
        id: "1623",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3132401401_1_audi_sport_softshell%20hoodie_unisex_grey.jpg"
    },
    {
        name: "Audi Sport Watch, Mens, black/red",
        id: "1629",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3102400100_1_audi_sport_watch_mens_black.jpg"
    },
    {
        name: "Audi Bottle, vacuum isolated, black",
        id: "162b",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3292400600_1_audi_active_bottleVacuum_black.jpg"
    },
    {
        name: "Audi Sport baby shoes, white/red",
        id: "1633",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3202300900_1_audi_casual_babyshoes.jpg"
    },
    {
        name: "Audi Junior quattro Kids red",
        id: "a28",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3201810010.jpeg"
    },
    {
        name: "Audi Sport Key ring motorsport bear",
        id: "aff",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3181900100.jpeg"
    },
    {
        name: "Audi Sport Rainjacket, Unisex, red",
        id: "f34",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3132101311_1_audi_sport_impermeable_unisex.jpg"
    },
    {
        name: "Audi Cap Premium, night blue",
        id: "ed6",
        image: "https://www.appsaudi.com.mx/resources/images/boutique/3132103200.jpeg"
    }
];

export default bannerArticles;
